import { render, staticRenderFns } from "./card-total-watch-time.vue?vue&type=template&id=2bfbac8e&"
import script from "./card-total-watch-time.vue?vue&type=script&lang=js&"
export * from "./card-total-watch-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports